<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<form #df="ngForm" novalidate class="formborder">
  <div class="row m-0 col-md-12 p-0">
    <div class="col-md-2">
      <span class="required-lable"> To Date </span>
      <div class="datepicker_feild">
        <input
          [matDatepicker]="picker"
          dateConvert
          placeholder="DD/MM/YYYY"
          name="searchDate"
          id="searchDate"
          required
          #refsearchDate="ngModel"
          class="form-control input-text-css"
          [(ngModel)]="searchDate"
          [ngClass]="{
            'is-invalid': df.submitted && refsearchDate.invalid,
            'alert-warning':
              refsearchDate.invalid &&
              (refsearchDate.dirty ||
                refsearchDate.touched ||
                refsearchDate.untouched)
          }"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>
    <div class="col-md-3">
      <span class="required-lable">Search Type</span>
      <select
        name="searchType"
        id="searchType"
        #refsearchType="ngModel"
        [(ngModel)]="searchType"
        [ngClass]="{
          'is-invalid': df.submitted && refsearchType.invalid,
          'alert-warning':
            refsearchType.invalid &&
            (refsearchType.dirty ||
              refsearchType.touched ||
              refsearchType.untouched)
        }"
        (change)="ResetField()"
        class="form-control input-text-css"
        required
      >
        <option value="Stock">Stock</option>
        <option value="Interest">Interest</option>
        <option value="Installment">Installment</option>
      </select>
    </div>

    <div class="col-md-4 mb-2">
      <button
        type="button"
        (click)="GetReportPortfolioDifference()"
        class="mt-3 btn font-size-12 button-btn"
        [disabled]="!df.form.valid"
      >
        Search
      </button>
    </div>

    <div class="col-md-3 mt-3" [hidden]="!dataSource">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Table -->
  <div class="mt-3" [hidden]="!dataSource">
    <div class="">
      <div class="table-responsive" style="overflow: auto; height: 65vh">
        <table
          mat-table
          class="table-bordered"
          matSort
          [dataSource]="dataSource"
          matTableExporter
          #exporter="matTableExporter"
          id="DueList"
        >
        <ng-container matColumnDef="Id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </td>
          <th mat-footer-cell *matFooterCellDef></th>
        </ng-container>
          <ng-container matColumnDef="LoanAcNo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Loan A/C No
            </th>
            <td mat-cell *matCellDef="let row">{{ row.LoanAcNo }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Loan_Date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Loan Date</th>
            <td mat-cell *matCellDef="let row">{{ row.Loan_Date }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Application_LTV">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>LTV</th>
            <td mat-cell *matCellDef="let row">{{ row.Application_LTV }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Application_AgreementValue">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Agreement Value
            </th>
            <td mat-cell *matCellDef="let row" class="text-right">
              {{ row.Application_AgreementValue }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="ExpiryDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Expiry Date
            </th>
            <td mat-cell *matCellDef="let row">{{ row.ExpiryDate }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="CustomerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Customer Name
            </th>
            <td mat-cell *matCellDef="let row">{{ row.CustomerName }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Gender">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender</th>
            <td mat-cell *matCellDef="let row">{{ row.Gender }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Branch_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Branch Name
            </th>
            <td mat-cell *matCellDef="let row">{{ row.Branch_Name }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Product_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
            <td mat-cell *matCellDef="let row">{{ row.Product_name }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Loan_Acc_Category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Account Category
            </th>
            <td mat-cell *matCellDef="let row">{{ row.Loan_Acc_Category }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Application_Case_IRR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>IRR</th>
            <td mat-cell *matCellDef="let row">
              {{ row.Application_Case_IRR | number : "1.2-2" }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Application_LoanTenure">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Loan Tenure
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.Application_LoanTenure }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="EMIAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              EMI Amount
            </th>
            <td mat-cell *matCellDef="let row">{{ row.EMIAmount }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PlanBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Plan Balance
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PlanBalance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="VoucherBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Voucher Balance
            </th>
            <td mat-cell *matCellDef="let row">{{ row.VoucherBalance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
          <ng-container matColumnDef="DifferenceBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Difference Balance
            </th>

            <td mat-cell *matCellDef="let row">
              {{ (row.PlanBalance || 0) - (row.VoucherBalance || 0) }}
            </td>

            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Closing">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Closing</th>
            <td mat-cell *matCellDef="let row">{{ row.Closing }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="AccountId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Account ID
            </th>
            <td mat-cell *matCellDef="let row">{{ row.AccountId }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Account_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Account Name
            </th>
            <td mat-cell *matCellDef="let row">{{ row.Account_Name }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="CorrectAccountId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Correct Acc ID
            </th>
            <td mat-cell *matCellDef="let row">{{ row.CorrectAccountId }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="CorrectAccountName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Correct Acc Name
            </th>
            <td mat-cell *matCellDef="let row">{{ row.CorrectAccountName }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
            class="sticky-footer fontcolor"
            style="background: var(--theme-primary)"
          ></tr>
          <tr
            mat-row
            (click)="highlightRow(row)"
            [class.highlight]="row.Loan_Id == selectedId"
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
          <!-- <tr
            mat-footer-row
            class="sticky-footer fontcolor"
            *matFooterRowDef="displayedColumns; sticky: true"
            style="background: var(--theme-primary)"
          ></tr> -->
        </table>
      </div>
    </div>
  </div>
  <div class="row m-0 ml-3" [hidden]="!dataSource">
  <div class="col-md-4 mt-3">
    <button class="mt-3 btn font-size-12 button-btn" (click)="exportexcelNew()">
      <i
        class="fa fa-file-export mr-1"
        style="font-size: medium; cursor: pointer"
      ></i>
      Export
    </button>
  </div>
  <div class="col-md-8 mt-3">
    <mat-paginator
      #paginatorRef
      [pageSizeOptions]="[20, 50]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
</form>
<table
  id="exposure_portfolio_difference"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <thead>
    <tr>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Loan Acc No</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Loan Date</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">LTV</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Agreement Value</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Expiry Date</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Customer Name</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Gender</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Branch Name</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Product Name</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Account Category</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">IRR</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Loan Tenure</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">EMI Amount</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Plan Balance</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Voucher Balance</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Difference Balance </th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Closing</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Account ID</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Account Name</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Correct Acc ID</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">Correct Acc Name</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let x of JsonData; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ x.LoanAcNo }}</td>
      <td>{{ x.Loan_Date }}</td>
      <td>{{ x.Application_LTV }}</td>
      <td>{{ x.Application_AgreementValue }}</td>
      <td>{{ x.ExpiryDate }}</td>
      <td>{{ x.CustomerName }}</td>
      <td>{{ x.Gender }}</td>
      <td>{{ x.Branch_Name }}</td>
      <td>{{ x.Product_name }}</td>
      <td>{{ x.Loan_Acc_Category }}</td>
      <td>{{ x.Application_Case_IRR | number : "1.2-2" }}</td>
      <td>{{ x.Application_LoanTenure }}</td>
      <td>{{ x.EMIAmount }}</td>
      <td>{{ x.PlanBalance }}</td>
      <td>{{ x.VoucherBalance }}</td>
      <td>{{ (x.PlanBalance || 0) - (x.VoucherBalance || 0) }}</td>
      <td>{{ x.Closing }}</td>
      <td>{{ x.AccountId }}</td>
      <td>{{ x.Account_Name }}</td>
      <td>{{ x.CorrectAccountId }}</td>
      <td>{{ x.CorrectAccountName }}</td>
    </tr>
  </tbody>
</table>

